import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { SYSTEMSETTING_SEGMENTS_MENU, SYSTEMSETTING_SEGMENTS } from '@model';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// Define permission constants
const PERMISSIONS = {
  SERVICE_CONTROL: 'ServiceControl.Permission',
};

const MenuCard = ({ label, icon, path }) => (
  <div className="box">
    <div className="card-wrapper">
      <Link to={path} className="card">
        <li>
          <div className="module-icon">
            <span className={`appkiticon icon-${icon}-fill`} />
            <span className="text">{label}</span>
          </div>
        </li>
      </Link>
    </div>
  </div>
);

const renderSettingMenu = (rootPath, hasServiceControlPermission) => {
  let menu = SYSTEMSETTING_SEGMENTS_MENU;

  if (!hasServiceControlPermission) {
    menu = menu.filter(
      (m) => !m.path.includes(SYSTEMSETTING_SEGMENTS.whitelist),
    );
  }

  return menu.map(({ path, icon, label }) => (
    <MenuCard key={path} path={rootPath + path} label={label} icon={icon} />
  ));
};

// Helper function to check if user has a specific permission
const hasPermission = (permissions, permissionKey) => {
  if (!permissions || !Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(permissionKey);
};

function SystemSettingPortal({ rootPath }) {
  // Option 1: Use Redux (recommended)
  const { userInfo } = useSelector(({ login }) => ({
    userInfo: login.userInfo || {},
  }));

  // Option 2: Use localStorage (if Redux is not available)
  // const storedUserInfo = window.localStorage.getItem('gateway-userInfo');
  // let userInfo = {};
  // if (storedUserInfo) {
  //   try {
  //     userInfo = JSON.parse(storedUserInfo);
  //   } catch (e) {
  //     console.error('Failed to parse userInfo from localStorage', e);
  //   }
  // }

  // Check if user has ServiceControl.Permission
  const hasServiceControlPermission = hasPermission(
    userInfo?.permissions,
    PERMISSIONS.SERVICE_CONTROL,
  );

  return (
    <>
      <ul className="module-list">
        {renderSettingMenu(rootPath, hasServiceControlPermission)}
      </ul>
    </>
  );
}

SystemSettingPortal.propTypes = {
  rootPath: PropTypes.string.isRequired,
};

export default memo(SystemSettingPortal);
